import { IItemTimeLine } from '@src/Domain/DUMEvents/DUMEvents.type';

export const getPositionAnimation = ({
  width,
  allItems,
  indexItem
}: {
  width: number;
  indexItem: number;
  allItems: IItemTimeLine[];
}) => {
  //?NOTE: Function for to get position animation

  let positionStart!: number;
  let positionEnd!: number;
  let lastItem!: number;

  switch (true) {
    case width > 1659:
      positionStart = 5;
      positionEnd = 0;
      lastItem = 10;
      break;
    case width > 1279.5 && width < 1659:
      positionStart = 4;
      positionEnd = 1;
      lastItem = 10;
      break;
    case width > 639 && width < 1279:
      positionStart = 4;
      positionEnd = 4;
      lastItem = 10;
      break;
    default:
      positionStart = 3;
      positionEnd = 7;
      lastItem = 3;
      break;
  }

  const widthBox = 140;
  const totalEvent =
    allItems.length >= 9 ? allItems.length - lastItem : allItems.length;
  const indexStart = indexItem - positionStart;

  const sumLast =
    indexStart > totalEvent
      ? -widthBox * (totalEvent + positionEnd)
      : -widthBox * indexStart;
  let position = indexItem < positionStart ? 0 : sumLast;
  if (indexItem >= positionStart && indexItem <= totalEvent - positionStart) {
    position = -widthBox * indexStart;
  }
  return position;
};

export const handleFindMytic = (data: IItemTimeLine[]) => {
  //?NOTE: Function for find data event Mytic

  const allItems = data;
  const eventMythic = [];
  for (let i = 0; i >= 0 && i < allItems.length; i++) {
    const e = allItems[i];
    if ('isMythicEvent' in e && e.isMythicEvent) {
      eventMythic.push(i + 1);
    }
  }

  return eventMythic;
};
